export function dataInRequest(params = {}) {
  return {
    type: '@estoqueGeralModulosProdutos/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@estoqueGeralModulosProdutos/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@estoqueGeralModulosProdutos/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@estoqueGeralModulosProdutos/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@estoqueGeralModulosProdutos/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@estoqueGeralModulosProdutos/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@estoqueGeralModulosProdutos/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@estoqueGeralModulosProdutos/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@estoqueGeralModulosProdutos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@estoqueGeralModulosProdutos/RECORD_FILTERING',
    payload: { params },
  };
}
